"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard"),
    _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck")),
    _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass")),
    _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits")),
    _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn")),
    _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf")),
    _react = _interopRequireWildcard(require("react")),
    _uiKit = require("@devsta/ui-kit");

require("../styles/_interactive-overlay.scss");

function _createSuper(Derived) {
  return function () {
    var result,
        Super = (0, _getPrototypeOf2["default"])(Derived);

    if (_isNativeReflectConstruct()) {
      var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else result = Super.apply(this, arguments);

    return (0, _possibleConstructorReturn2["default"])(this, result);
  };
}

function _isNativeReflectConstruct() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;

  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
  } catch (e) {
    return !1;
  }
}

var InteractiveOverlay = function (_Component) {
  function InteractiveOverlay() {
    var _this;

    return (0, _classCallCheck2["default"])(this, InteractiveOverlay), _this = _super.call(this), _this.onHover = function () {
      var hovering = _this.state.hovering;
      hovering || _this.setState({
        hovering: !0
      });
    }, _this.onHoverOut = function () {
      _this.setState({
        hovering: !1
      });
    }, _this.state = {
      hovering: !1
    }, _this;
  }

  (0, _inherits2["default"])(InteractiveOverlay, _Component);

  var _super = _createSuper(InteractiveOverlay);

  return (0, _createClass2["default"])(InteractiveOverlay, [{
    key: "getPreviewOverlay",
    value: function getPreviewOverlay() {
      var hovering = this.state.hovering,
          _this$props = this.props,
          playing = _this$props.playing,
          onPause = _this$props.onPause,
          onPlay = _this$props.onPlay,
          onRestart = _this$props.onRestart,
          getCurrentTime = _this$props.getCurrentTime,
          loading = _this$props.loading;
      if (loading) return _react["default"].createElement("div", {
        className: "interactive-overlay"
      }, _react["default"].createElement(_uiKit.Icon, {
        className: "interactive-overlay__loading",
        name: "shootstagrad",
        size: 40,
        color: "white",
        spin: !0
      }));
      if (playing && !hovering) return null;
      var currentTime = getCurrentTime ? getCurrentTime() : 0;
      return _react["default"].createElement("div", {
        className: "interactive-overlay"
      }, 0 < currentTime && !playing ? _react["default"].createElement(_uiKit.Icon, {
        className: "interactive-overlay__restart",
        onClick: onRestart,
        name: "previous",
        size: 42,
        color: "white"
      }) : null, playing ? _react["default"].createElement(_uiKit.Icon, {
        key: "pause",
        className: "interactive-overlay__pause",
        name: "pause",
        size: 35,
        color: "white",
        onClick: onPause
      }) : null, playing ? null : _react["default"].createElement(_uiKit.Icon, {
        key: "play",
        className: "interactive-overlay__play",
        name: "play",
        size: 35,
        color: "white",
        onClick: onPlay
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children,
          hovering = this.state.hovering;
      return children({
        overlay: this.getPreviewOverlay(),
        hovering: hovering,
        onMouseOver: this.onHover,
        onMouseLeave: this.onHoverOut
      });
    }
  }]), InteractiveOverlay;
}(_react.Component);

exports["default"] = InteractiveOverlay;